import { defineComponent as _defineComponent } from 'vue'
import type { EditorialListTitleFragment } from '@/pages/graphql/fragments/EditorialListTitle.fragment';

import BasicButton from '@/ui-components/BasicButton.vue';
import BuyBox from '@/components/buybox/BuyBox.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import TitleScoreList from '@/components/TitleScoreList.vue';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';
import TextCollapse from '@/components/TextCollapse.vue';

import { clickOnReadMore, clicksOnTitle } from '@/pages/editorial/tracking';
import TitleActionsProvider, { ListActionableTitle, isInWatchList } from '@/helpers/providers/title-actions-provider';

import { ObjectType } from '@/@types/graphql-types';
import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';
import { computed } from 'vue';
import { useI18n } from '@/helpers/composables/useI18n';
import { useWindowSize } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListArticleItem',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as {
	title: EditorialListTitleFragment;
};



const { width } = useWindowSize();

const shortDescriptionClamp = computed(() => (width.value > 768 ? 7 : 13));

const { t } = useI18n();

const isTitleInWatchList = computed(() => isInWatchList(props.title as ListActionableTitle));

const watchlistActionLabel = computed(() => {
	if (props.title.objectType === ObjectType.Movie) {
		return t('WEBAPP_WATCHLIST');
	}

	return isTitleInWatchList.value ? t('WEBAPP_TRACKING') : t('WEBAPP_WATCHLIST_TV_SHOW_START_TRACKING');
});

/* TRACKING */
function trackClicksOnTitle() {
	const titleContext = new SnowplowTitleContextGraphql(props.title.objectId, props.title.objectType);
	clicksOnTitle({
		category: 'userinteraction',
		action: 'title_clicked',
		label: 'editorial-lists',
		contexts: [titleContext],
	});
}

function trackClickOnReadMore(target: EventTarget | null) {
	if (!target) return;

	clickOnReadMore({
		category: 'content_header',
		action: (target as HTMLInputElement).checked ? 'expanded' : 'collapsed',
	});
}

return { __sfc: true,props, width, shortDescriptionClamp, t, isTitleInWatchList, watchlistActionLabel, trackClicksOnTitle, trackClickOnReadMore, BasicButton, BuyBox, PictureComp, TitleScoreList, TitleDetailLink, TextCollapse, TitleActionsProvider }
}

})